<template>
    <Transition name="fade" :appear="isLoading">
        <div class="chat-loading-frame" data-testid="chat-loading-frame" :data-loading="isLoading">
            <LoadingSpinner v-if="isLoading" class="loading-spinner h-4 w-4" />
            <slot v-else name="icon">
                <i class="bi bi-check-lg" aria-hidden="true" />
            </slot>
            <span>
                <slot>{{ t("chat.loading.default") }}</slot>
            </span>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

withDefaults(defineProps<{ isLoading?: boolean }>(), {
    isLoading: false,
});
</script>

<style scoped>
@reference "../../css/tailwind.css";

@layer components {
    .chat-loading-frame {
        @apply transition-colors nadia-chat leading-[normal] bg-surface-raised text-ink border-2 border-border-strong flex items-center gap-3 py-4 px-6 rounded-tl-lg rounded-tr-3xl rounded-br-3xl rounded-bl-3xl;

        &[data-loading="false"] {
            @apply bg-surface-sunken border-border text-ink-muted;
        }

        &:where(html[data-theme="tonal"] *) {
            @apply scaffold-body-small text-ink border p-2.5 rounded-md;

            &[data-loading="false"] {
                @apply bg-surface-sunken border-border-strong text-ink;
            }
        }
    }

    .loading-spinner {
        @apply text-ink-muted;

        &:where(html[data-theme="tonal"] *) {
            @apply text-ink;
        }
    }
}
</style>
